var map = {
	".": 1388,
	"./": 1388,
	"./action": 6,
	"./action.js": 6,
	"./index": 1388,
	"./index.js": 1388,
	"./label": 3255,
	"./label.js": 3255,
	"./menu": 1543,
	"./menu.js": 1543,
	"./message": 6703,
	"./message.js": 6703,
	"./response": 8369,
	"./response.js": 8369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2578;